import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async postInForum({ }, post) {
      let response = (await Vue.http.post(this.state.baseUrl + '/forum/posts/_post', post)).data
      return response
    },
    async getReplies({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/forum/posts/replies/' + options.postId + '?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
      return response
    },
    async getForumPosts({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + '/forum/posts?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
      return response
    },

    async searchForumPost({ }, options) {
      let response = (await Vue.http.get(this.state.baseUrl + `/forum/posts/search/${options.searchStr}?pageNumber=` + options.pageNumber + '&pageSize=' + options.pageSize)).data
      return response
    },

    async getForumPostById({ }, id) {
      let response = (await Vue.http.get(this.state.baseUrl + `/forum/posts/${id}`)).data
      return response
    },

    async toggleLike({ }, options) {
      let response = (await Vue.http.post(this.state.baseUrl + '/forum/posts/toggle-like/' + options.postId, { userId: options.userId })).data
      return response
    },

    async deletePost({ }, options) {
      let response = (await Vue.http.delete(this.state.baseUrl + '/forum/posts/delete/' + options.postId)).data
      return response
    },

    async updatePost({ }, options) {
      let response = (await Vue.http.put(this.state.baseUrl + '/forum/posts/update/' + options.postId, { title: options.title, description: options.description, attachments: options.attachments })).data
      return response
    }
  }
}
